import { render, staticRenderFns } from "./preVenda.vue?vue&type=template&id=185c7936"
import script from "./preVenda.ts?vue&type=script&lang=js&external"
export * from "./preVenda.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('185c7936')) {
      api.createRecord('185c7936', component.options)
    } else {
      api.reload('185c7936', component.options)
    }
    module.hot.accept("./preVenda.vue?vue&type=template&id=185c7936", function () {
      api.rerender('185c7936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/manipulacao/preVenda.vue"
export default component.exports